import { dataHomeAltSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHomeAltSolid = /*#__PURE__*/createIcon(dataHomeAltSolid)
export default IconHomeAltSolid
